import { type ColumnsState, createColumnsHook } from './createColumnsHook';

/** Ordem de exibição. "Profissional" fica de fora: é o que identifica a linha, sempre visível. */
export const POOL_COLUMNS = [
  'profile',
  'allocatedPercentage',
  'billable',
  'contractType',
  'currency',
  'allocatedCost',
  'startDate',
  'notified',
  'noticeDate',
  'noticeDays',
  'endDate',
  'notes',
  'tags',
  'responsible',
  'lastProject',
] as const;

export type PoolColumn = (typeof POOL_COLUMNS)[number];

export const POOL_COLUMN_LABEL_KEYS = {
  profile: 'consultas.colunas.perfil',
  allocatedPercentage: 'tabela.percAlocado',
  billable: 'tabela.faturando',
  contractType: 'consultas.colunas.tipo',
  currency: 'consultas.colunas.moeda',
  allocatedCost: 'tabela.custoAlocado',
  startDate: 'consultas.colunas.poolDesde',
  notified: 'consultas.colunas.avisado',
  noticeDate: 'consultas.colunas.avisadoEm',
  noticeDays: 'consultas.colunas.numeroDias',
  endDate: 'consultas.colunas.fimAlocacao',
  lastProject: 'consultas.colunas.ultimaAlocacao',
  responsible: 'consultas.colunas.responsavel',
  notes: 'filtros.anotacoes',
  tags: 'form.tags',
} as const satisfies Record<PoolColumn, string>;

export const usePoolColumns = createColumnsHook({
  columns: POOL_COLUMNS,
  // Padrão: todas visíveis.
  defaultColumns: POOL_COLUMNS,
  storageKey: 'pool-table-columns',
  version: 4,
});

export type PoolColumnsState = ColumnsState<PoolColumn>;
